import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Al ir a otra página (enlace o navigate), arriba del todo; al volver con
 * «Atrás» (POP) no se toca: la cartelera recupera su propio scroll y el resto
 * lo restaura el navegador. Sin esto, la ficha se abría a la altura a la que
 * estaba la lista (29-10-2026).
 */
export function ScrollManager() {
  const { pathname } = useLocation();
  const type = useNavigationType();
  useEffect(() => {
    if (type !== "POP") window.scrollTo(0, 0);
  }, [pathname, type]);
  return null;
}
